const translations = {
    duplicateError: 'This pesticide license already exists.',
    save: 'Save License',
    saveError: 'Something went wrong. Please try again.',
    title: 'Add Pesticide License'
};

export default translations;
